<template>
    <div class="shipDetail-pcpMenuCon">
        <div class="pcpMenuCon-secondMenuList" v-if="subCategories && subCategories.length > 1">
            <div class="pcpMenuCon-secondMenu" v-for="(subCategory, i) in subCategories" :key="('subCategoryMenu_'+i)"
            :class="{ active: currentSubCategory==subCategory}"
            @click="onSubCategoryClick(subCategory)" v-show="getItemListBySubCategories(subCategory).length>0">
                <p class="">{{subCategory}}<span>({{getItemListBySubCategories(subCategory).length}})</span></p>
                <span class="menuBorderActive"></span>
            </div>
        </div>

        <div class="pcpMenuCon-menuPicsCon">
            <div class="pcpMenuCon-menuPics" v-for="(subCategory, i) in subCategories" :key="('subCategoryGroup_'+i)"
            v-show="currentSubCategory==subCategory">
                <div class="" :class="{ 'pcpMenuCon-menuPics-bigPic': j == 0, 'pcpMenuCon-menuPics-smallPic': j > 0}" 
                    @click="onItemClick(item)"
                    v-for="(item, j) in getItemListBySubCategories(subCategory)" :key="('item_'+item.id)">
                    <img v-lazy="item.image" :alt="item.name">
                    <div class="pcpMenuCon-menuPics-txt">{{item.name}}</div>
                    <div v-if="item.ships.indexOf('海洋光谱号')!==-1&&item.vrUrl && item.vrUrl.length>0" class="viewVrMiniSite">
                      <img src="https://resource.rcclchina.com.cn/wechatMiniProgram/vrImg/vrIcon.png" alt="">
                    </div>
                </div>
            </div>
        </div>

        <div class="secondMenuListActive" v-show="isMenuFixed" v-if="subCategories && subCategories.length > 1">
            <div class="pcpMenuCon-secondMenuList">
                <div class="pcpMenuCon-secondMenu" 
                 v-for="(subCategory, i) in subCategories" :key="('subCategoryMenu_'+i)"
            :class="{ active: currentSubCategory==subCategory}"
            @click="onSubCategoryClick(subCategory)" v-show="getItemListBySubCategories(subCategory).length>0">
                    <p class="">{{subCategory}}<span>({{getItemListBySubCategories(subCategory).length}})</span></p>
                    <span class="menuBorderActive"></span>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: "ShipExperienceGroup",
    props: {
        items: {
            type: Array,
            default () {
                return []
            }
        },
        subCategories: {
            type: Array,
            default () {
                return []
            }
        },
        category: {
            type: String
        },
        onItemClick: {
            type: Function
        },
        isMenuFixed: {
            type: Boolean
        },
        scrollToStart: {
            type: Function
        }
    },
    beforeMount () {
        if (this.subCategories && this.subCategories.length > 0 && this.currentSubCategory == "") {
            this.currentSubCategory = this.subCategories[0]
        }
    },
    data () {
        return {
            currentSubCategory: ""
        }
    },
    methods: {
        getItemListBySubCategories (subCategory) {
            if (subCategory == '') return this.items

            return this.items.filter(r=> r.subCategory == subCategory)
        },
        onSubCategoryClick (subCategory) {
            this.currentSubCategory = subCategory
            this.scrollToStart()
        }
    },
    computed: {
      shipCode () {
        const params = this.$router.currentRoute.params || {}
        return params.shipCode || ""
      }
    },
    watch: {
        subCategories (newValue) {
            if (newValue && newValue.length > 0 && this.currentSubCategory == "") {
                this.currentSubCategory = newValue[0]
            }
        }
    }
}
</script>

<style lang="less" scoped>
.f-dn { display: none !important }

.shipDetail-pcpMenuCon {
    .pcpMenuCon-secondMenuList {
        overflow: hidden;
        clear: both;
        border-bottom: 1px solid #eee;
        padding: 0 3.2%;
        text-align: center;
        background-color: #fff;
        position: relative;
        .pcpMenuCon-secondMenu {
            display: inline-block;
            margin-right: 3.6%;
            margin-bottom: 5px;
            p {
                color: #333;
                font-size: 12px;
                transform: scale(.95);
                -webkit-transform: scale(.95);
                -moz-transform: scale(.95);
                -o-transform: scale(.95);
                margin: 9px 0;
            }
            .menuBorderActive {
                display: none;
                width: 31px;
                height: 3px;
                background-color: #f0af11;
                border-radius: 30px;
                margin: 0 auto;
            }
        }

        .pcpMenuCon-secondMenu.active {
            p {
                color: #061556;
                font-size: 13px;
                font-weight: bolder;
            }
            .menuBorderActive {
                display: block;
            }
        }
    }

    .pcpMenuCon-menuPicsCon {
        .pcpMenuCon-menuPics {
            margin-top: 7px;
            clear: both;
            overflow: hidden;
            padding: 0 3.2%;
            .pcpMenuCon-menuPics-bigPic {
                overflow: hidden;
                width: 100%;
                height: 245px;
                position: relative;
                margin-bottom: 3%;
                img {
                    width: 103%;
                }
                .pcpMenuCon-menuPics-txt {
                    width: 100%;
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    background-color: rgba(0,0,0,.6);
                    color: #fff;
                    text-align: center;
                    font-size: 13px;
                    padding: 3px 4px;
                }
            }
            .pcpMenuCon-menuPics-smallPic {
                float: left;
                width: 172px;
                height: 121px;
                position: relative;
                margin-bottom: 1.3%;
                overflow: hidden;
                margin-bottom: 1.3%;
                img {
                    width: 105%;
                }
                .pcpMenuCon-menuPics-txt {
                    width: 100%;
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    background-color: rgba(0,0,0,.6);
                    color: #fff;
                    text-align: center;
                    font-size: 13px;
                    padding: 3px 4px;
                }
            }
            .pcpMenuCon-menuPics-smallPic:nth-child(2n) {
                margin-right: 1.3%;
            }
        }
        
    }
    
    .secondMenuListActive {
        width: 100%;
        position: fixed;
        top: 102px;
        z-index: 11;
    }
}
.viewVrMiniSite{
  position: absolute;
  width: 30px;
  height: 21px;
  overflow: hidden;
  top: 7px;
  right: 9px;
  z-index: 9;
  & img{
    width: 100%;
    height: 100%;
  }
}
</style>